$(document).ready(function ($) {
  if($('.logos-slider').length){
      $('.logos-slider').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 4500,
        arrows: false,
        swipe: false,
        slidesToShow: 4,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
        rtl: true,
        infinite: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      }); 
  }
  
  if($('.text-with-icon-2.mobile-slider-icon .row').length){
    $('.text-with-icon-2.mobile-slider-icon .row').slick({
        mobileFirst: true,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
       prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//cdn.shopify.com/s/files/1/0433/3282/9343/files/slider-arrow.png' alt='slider arrows'></button>",
       nextArrow:"<button type='button' class='slick-next pull-right'><img src='//cdn.shopify.com/s/files/1/0433/3282/9343/files/slider-arrow.png' alt='slider arrows'></button>",
        responsive: [
            {
               breakpoint:767,
                settings: "unslick"
            }
        ]
      }); 
  }
});
